import { SCROLLBAR_SIZE } from "@shared/common/Themes/AppTheme";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_VIRTUAL_LIST } from "common/constants";

const useGetVirtualListCardDimensions = (
  originalCardHeight: number,
  mobileCardHeight: number,
  originalCardWidth: number,
  mobileCardWidth: number
) => {
  const isMobile = useMedia(
    [`(max-width: ${MOBILE_VIRTUAL_LIST})`],
    [true],
    false
  );

  const getVirtualListCardHeight = () => {
    let height = originalCardHeight;
    if (isMobile) height = mobileCardHeight + SCROLLBAR_SIZE;

    return height + CARD_MARGIN;
  };

  const getVirtualListCardWidth = () => {
    let width = originalCardWidth;
    if (isMobile) width = mobileCardWidth;

    return width + CARD_MARGIN;
  };

  const cardHeight = getVirtualListCardHeight();
  const cardWidth = getVirtualListCardWidth();

  return { cardHeight, cardWidth };
};

export default useGetVirtualListCardDimensions;

const CARD_MARGIN = 16;
